import { useEffect, useState } from "react";
import api from "@/lib/api";

// Lista usuários (exceto administradores) para seleção do responsável comercial impresso na proposta.
export function ResponsavelSelect({ value, onChange, disabled, testid = "prop-responsavel" }) {
  const [users, setUsers] = useState([]);
  useEffect(() => { api.get("/users").then((r) => setUsers(r.data.filter((u) => u.role !== "admin" && u.role !== "diretor_operacional"))).catch(() => setUsers([])); }, []);
  return (
    <select className="select" value={value || ""} onChange={(e) => onChange(e.target.value)} disabled={disabled} data-testid={testid}>
      <option value="">— selecione o responsável comercial —</option>
      {users.map((u) => <option key={u.id} value={u.id}>{u.name}{u.cargo ? ` · ${u.cargo}` : ""}</option>)}
    </select>
  );
}
